module.exports = __webpack_public_path__ + "b4d3afdb.svg";